<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="packages"
			:loading="loading"
			class="elevation-1"
			:search="lookingFor"
		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

			<template #item.action="{item}">
				<action-td :item="item" module="package" @edit="onEdit"/>
			</template>

			<template #item.link="{item}">
				<a :href="item.link">{{item.link}}</a>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>

	import {types} from "src/store/modules/Package.module";
	import FilterAble from "src/mixins/FilterAble";
	import ActionTd from "src/components/AcationTd";

	export default {
		name: "packages-table",
		props: {lottery:Object},
		components: {
			ActionTd
		},
		data() {
			return {
				loading: false,
				headers: [
					{text: "מחיר", value: "price"},
					{text: "תשלומים", value: "num_of_payments"},
					{text: "כמות כרטיׁׁסים", value: "amount"},
					{text: "כותרת", value: "title"},
					{text: "תת כותרת", value: "subtitle"},
					{text: "מילות תודה", value: "thanks_words"},
					{text: "קישור", value: "link"},
					{text: "פעולות", value: "action", sortable: false}
				],
				lookingFor: null,
				showDialog: false
			};
		},
		computed: {
			packages() {
				return this.$store.state.PackageModule.packages;
			}
		},
		methods: {
			onEdit(Package) {
				this.$emit("edit", Package);
			}
		},
		created() {
			this.$store.dispatch(types.FETCH,{lottery_id:this.lottery.id});
		}
	}
	;
</script>

<style>

</style>
